import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/** The active tab of a section, kept in the URL search param so a reload and a link keep it. The default tab leaves the URL clean. */
export function useTabParam(validIds, fallback = validIds[0]) {
  const [params, setParams] = useSearchParams();
  const raw = params.get('tab');
  const value = validIds.includes(raw) ? raw : fallback;
  const setValue = useCallback((next) => {
    setParams((p) => {
      const n = new URLSearchParams(p);
      if (next === fallback) n.delete('tab'); else n.set('tab', next);
      return n;
    }, { replace: true });
  }, [setParams, fallback]);
  return [value, setValue];
}
